import { create } from 'zustand';
import { persist } from 'zustand/middleware';

// JWT のクレーム展開は backend が責任を持つ。Frontend では token と最小限の表示用情報のみ保持。

interface AuthUser {
  email?: string;
  displayName?: string;
}

interface AuthState {
  accessToken: string | null;
  user: AuthUser | null;
  setSession: (token: string, user: AuthUser) => void;
  clear: () => void;
}

export const useAuthStore = create<AuthState>()(
  persist(
    (set) => ({
      accessToken: null,
      user: null,
      setSession: (accessToken, user) => set({ accessToken, user }),
      clear: () => set({ accessToken: null, user: null }),
    }),
    {
      name: 'konecco-auth',
      partialize: (state) => ({
        accessToken: state.accessToken,
        user: state.user,
      }),
    },
  ),
);
